import styled from 'styled-components'

export const ActionsMenuWrapper = styled.div`
  position: relative;
  margin-left: auto;
`

export const ActionsMenuButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme.colorOrange};
  background: #ff99004d;
  color: ${(p) => p.theme.colorOrange};
  cursor: pointer;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(115%);
  }

  span {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
  }
`

export const ActionsDropdown = styled.div<{ show: boolean }>`
  display: ${(p) => (p.show ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 3rem;
  z-index: 99900009;
  min-width: 12rem;
  padding: 0.5rem;
  border: 1px solid ${(p) => p.theme.colorDividerDefault};
  border-radius: 12px;
  background-color: ${(p) => p.theme.colorSurfaceBase};
  ${(p) => p.theme.content};
`

export const ActionsDropdownItem = styled.div<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 0.75rem;
  height: 2.5rem;
  border-radius: 8px;
  cursor: pointer;
  color: ${(p) => (p.$danger ? p.theme.colorRed : p.theme.textColor)};

  svg {
    fill: ${(p) => (p.$danger ? p.theme.colorRed : p.theme.textColor)};
  }

  &:hover {
    background-color: ${(p) => p.theme.colorNeutrals600};
  }
`

export const PhaseList = styled.div`
  display: flex;
  flex-direction: column;
`

const phaseDotSize = '1rem'
const phaseDotOffset = '0.2rem'
const phaseDotCenter = '0.7rem'

export const PhaseItem = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
  padding-bottom: 1.5rem;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: calc(${phaseDotSize} / 2 - 1px);
    top: 0;
    height: ${phaseDotCenter};
    width: 2px;
    background: #ff9900;
    opacity: 0.5;
    z-index: 0;
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    left: calc(${phaseDotSize} / 2 - 1px);
    top: ${phaseDotCenter};
    height: calc(100% - ${phaseDotCenter});
    width: 2px;
    background: #ff9900;
    opacity: 0.5;
    z-index: 0;
  }
`

export const PhaseIndicator = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${phaseDotSize};
`

export const PhaseDot = styled.div`
  width: ${phaseDotSize};
  height: ${phaseDotSize};
  margin-top: ${phaseDotOffset};
  border-radius: 50%;
  background: #ff9900;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`

export const PhaseBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  border: 1px solid ${(p) => p.$color};
  background: ${(p) => p.$color}18;
  color: ${(p) => p.$color};
`

export const PhaseBadgeDot = styled.div<{ $color: string }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${(p) => p.$color};
`
